import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=13cf18fa&scoped=true&"
import script from "./Setup.vue?vue&type=script&lang=ts&"
export * from "./Setup.vue?vue&type=script&lang=ts&"
import style0 from "./Setup.vue?vue&type=style&index=0&id=13cf18fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cf18fa",
  null
  
)

export default component.exports